import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http';
import { SesionService } from '../services/sesion.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CONFIG } from '../constants/constants';
import { UtilService } from '../services/util.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
    cReq = 0;
    cRes = 0;

    constructor(
        private sesionService: SesionService,
        private router: Router,
        private _util: UtilService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this.cReq++;

        const jwt = sessionStorage.getItem('token');
        if (jwt) {
            const headers = new HttpHeaders({
                Authorization: `Bearer ${jwt}`,
            });

            if (!req.url.includes('geo')) {
                req = req.clone({
                    headers: headers,
                });
            }
        }

        return next.handle(req).pipe(
            map((event) => {
                //muestra el loading para todos los servicios menos para estadisticas
                if (!req.url.includes('refresh-token')) {
                    this._util.displaySpinner = true;
                }

                if (event instanceof HttpResponse) {
                    this.cRes++;
                    if (this.cReq <= this.cRes) {
                        this._util.displaySpinner = false;
                        this.cReq = 0;
                        this.cRes = 0;
                    }
                    return event;
                }
            }),
            catchError((e: HttpErrorResponse) => {
                this._util.displaySpinner = false;
                this.cReq = 0;
                this.cRes = 0;
                if (e.status && e.status >= 400 && e.status < 600) {
                    // Verificar si el e es un e de servidor interno (500) al editar un usuario
                    if (
                        e.status === 500 &&
                        e.url?.includes('/usuario/agente-vigilado')
                    ) {
                        Swal.fire(
                            e.error.error_description,
                            e.error.message,
                            'warning'
                        );
                        console.log(e);
                        return; // Evitar mostrar la alerta
                    }
                    if (
                        e.status === 500 &&
                        e.url?.includes(
                            '/representante-agente-vigilado/Keycloack'
                        )
                    ) {
                        console.log(
                            'Ocurrió un error al cargar el usuario. Es posible que el usuario no exista.'
                        );
                        return; // Evitar mostrar la alerta
                    }
                }
                if (
                    e.status == 0 &&
                    !e.url?.includes('/representante-agente-vigilado/Keycloack')
                ) {
                    Swal.fire(
                        'Error inesperado',
                        'Sistema fuera de servicio, por favor intente más tarde',
                        'error'
                    );
                    //this.router.navigate(CONFIG.LOGIN_PAGE);
                } else if (
                    e.status == 204 &&
                    !e.url?.includes('/representante-agente-vigilado/Keycloack')
                ) {
                    Swal.fire(
                        'Error inesperado',
                        'Por favor intente más tarde',
                        'error'
                    );
                } else if (
                    e.status == 401 &&
                    !e.url?.includes('/representante-agente-vigilado/Keycloack')
                ) {
                    //Usuario y contraseña incorrectos
                    if (e.url.includes('login')) {
                        Swal.fire(
                            'Usuario y contraseña incorrectos',
                            'Por favor valide y vuelva a intentar',
                            'warning'
                        );
                    } else {
                        Swal.fire(
                            'Permiso denegado',
                            'Por valide la sesión de usuario',
                            'warning'
                        );
                    }
                } else if (e.status == 403) {
                    if (this.sesionService.isAuthenticated()) {
                        this.sesionService.logOut();
                    }
                    this.router.navigate(CONFIG.LOGIN_PAGE);
                    Swal.fire(e.error.message, e.message, 'error');
                } else if (e.status == 404) {
                    //-------------------------------------NOT_FOUND
                } else if (e.status == 500) {
                    Swal.fire(
                        'Se ha presentado un error',
                        'Por favor intente más tarde',
                        'error'
                    );
                    //this.router.navigate(['/inicio/']);
                }
                /*
        else {
          let errorMsg = '';
          let errorDetail = '';

          if (e.error instanceof ErrorEvent) {
            // error en el cliente :ejem caida internet
            errorMsg = `No hay comunicación con el servidor`;
            errorDetail = 'Favor verifique la red ó comuniquese con el administrador';
          } else {
            errorMsg = `Ocurrio un error inesperado`;

            if (e instanceof HttpErrorResponse) {
              console.log('si es HttpErrorResponse');
              errorDetail = `Error: ${e.message}`;
            } else {
              errorDetail = 'Error: ' + JSON.stringify(e);
              //errorDetail = `${e.error.titulo}: ${e.error.descripcion}`;
            }
            // error en el servidor :ejem caida servidor
          }
          Swal.fire({
            icon: 'error',
            title: errorMsg,
            text: errorDetail
          });

        }
        */

                return throwError(e);
            })
        );
    }
}
